<template>
    <footer>
        <div>AirPro Auggie Management {{ version() }}</div>
        <div>Copyright © {{ getYears() }} AirPro Diagnostics LLC</div>
    </footer>
</template>

<style scoped lang="scss">
    footer {
        margin-top:3em;
        text-align:center;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            STARTYEAR: 2021,
        };
    },
    methods: {
        version(): string {
            if (!import.meta.env.VITE_VERSION) throw new Error("VITE_VERSION not defined in .env");
            return import.meta.env.VITE_VERSION;
        },
        getYears(): string {
            const year = this.thisYear();
            if (year !== this.STARTYEAR) {
                return `${this.STARTYEAR}-${year}`;
            } else {
                return year.toString();
            }
        },
        thisYear(): number {
            return new Date().getFullYear();
        },
    },
});
</script>
